export default __webpack_public_path__ + "static/media/414.9dd26baf.png";